import {
    projectsSelector,
    groupsSelector,
    selectedProjectsSelector,
    selectedGroupsSelector,
    timePeriodsSelector,
    environmentTypesSelector
} from '../../../selectors/base';

import {
    summariesSelector,
    dataSelector,
    viewInfoSelector,
    filtersSelector,
    summarySelector,
    loadingSelector,
    excludedItemsSelector,
    timePeriodInfoSelector
} from './../../../selectors/change-volume';

import { editModeSelector } from '../../../selectors/settings';

export default class changeVolumeController {
    static $inject = ['$ngRedux','ChangeVolumeActions','$scope','$element','widgetsHelper'];
    constructor($ngRedux, ChangeVolumeActions, $scope,$element,widgetsHelper) {
        'ngInject';
        this.widgetsHelper = widgetsHelper;
        this.unsubscribe = $ngRedux.connect(mapStateToThis, ChangeVolumeActions)(this);
        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.$scope = $scope;
        this.$element = $element;
        this.customDate = { startDate: null, endDate: null };
        this.datePickerOptions = {
            eventHandlers: {
                'apply.daterangepicker': () => {
                    const start = this.customDate.startDate.valueOf();
                    const end = this.customDate.endDate.valueOf();
                    const customPeriod = this.timePeriods.find(t => t.custom);
                    return this.loadSpecific({ ...this.getLoadOptions(), timePeriod: customPeriod, start, end }, { summary: true, graph: true });
                }
            }
        }
    }

    getLoadOptions(graphType) {
        let start, end;
        const graph = graphType || this.filters.graphType;
        const { timePeriod, environmentType } = this.filters;
        const { projectIds, groupIds, environmentTypes } = this;
        const { summaryProjectIds, summaryGroupIds } = this.widgetsHelper.filterLoadData(this.excludedItems, this.projects, this.groups);
        if (timePeriod.custom) {
            start = this.timePeriodInfo.start;
            end = this.timePeriodInfo.end;
        } else {
            end = Date.now();
            start = end - timePeriod.periodInMilliseconds;
        }
        return {
            timePeriod,
            environmentTypes: graph === 'ChartGroup' ? environmentTypes : [environmentType],
            graphType: graph,
            projectIds,
            groupIds,
            start,
            end,
            summaryProjectIds,
            summaryGroupIds
        };
    }

    environmentTypeSelected(select) {
        if (!select) {
            return;
        }
        const result = this.environmentTypes.filter(envType => envType.id == select.id);
        if(result.length == 0) {
            select = this.environmentTypes[0];
            this.onEnvSelected(select);
        }
        return  select.name;
    }

    $onInit() {
        this.unwatchProjects = this.$scope.$watch(() => [ ...this.projectIds, ...this.groupIds], (newValues, oldValues) => {
            if (newValues !== oldValues) {
                this.loadSpecific(this.getLoadOptions(), { summary: true, graph: true });
            }
        }, true);
        this.loadSpecific(this.getLoadOptions(), { graph: true, summary: true });
        this.filters.environmentType = this.environmentTypeSelected(this.filters.environmentType);
        this.unwatchLegend = this.$scope.$watch(() => this.excludedItems, (newValues, oldValues) => {
            if (newValues !== oldValues) {
                this.loadSpecific({...this.getLoadOptions(), ...this.widgetsHelper.filterLoadData(newValues, this.projects, this.groups)}, { graph: false, summary: true });
            }
        }, true);
    }

    $onDestroy() {
        this.unwatchProjects();
        this.unsubscribe();
    }

    onTimeSelected(timePeriod) {
        if (timePeriod.custom) {
            this.$element.find('#change-volume-datepicker').click();
        } else {
            this.loadSpecific({ ...this.getLoadOptions(), timePeriod }, { summary: true, graph: true });
        }
    }

    onEnvSelected(environmentType) {
        this.loadSpecific({ ...this.getLoadOptions(), environmentTypes: [environmentType] }, { summary: false, graph: true });
    }

    onSummaryClick(summaryItem) {
        const index = this.summaries.indexOf(summaryItem);
        this.selectedSummaryChanged(index);
    }

    onGraphTypeChanged(graphType) {
        this.loadSpecific({ ...this.getLoadOptions(), graphType }, { summary: false, graph: true });
    }
}

function mapStateToThis(state) {
    return {
        projects: projectsSelector(state),
        groups: groupsSelector(state),
        projectIds: selectedProjectsSelector(state),
        groupIds: selectedGroupsSelector(state),
        summaries: summariesSelector(state),
        dataset: dataSelector(state),
        environmentTypes: environmentTypesSelector(state),
        timePeriods: timePeriodsSelector(state),
        summary: summarySelector(state),
        viewInfo: viewInfoSelector(state),
        filters: filtersSelector(state),
        loading: loadingSelector(state),
        editMode: editModeSelector(state),
        excludedItems: excludedItemsSelector(state),
        timePeriodInfo: timePeriodInfoSelector(state)
    };
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/change-volume/change-volume.controller.js